import { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { VideoModal, VideoCard } from '@/components/VideoModal';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export default function VRDemoVideosPage() {
  const [videos, setVideos] = useState([]);
  const [selectedVideo, setSelectedVideo] = useState(null);

  useEffect(() => {
    axios.get(`${API}/videos?page=vr-demo-videos`)
      .then(res => setVideos(res.data))
      .catch(console.error);
  }, []);

  return (
    <div className="min-h-screen pt-24" data-testid="vr-demo-videos-page">
      {/* Hero Section */}
      <section className="py-16">
        <div className="container-custom">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            className="max-w-4xl mx-auto text-center"
          >
            <h1 className="text-4xl md:text-6xl font-serif font-bold text-white mb-6" data-testid="demo-videos-title">
              Virtual Reality Campus Demo Videos
            </h1>
            <p className="text-xl text-muted-foreground">
              Watch demonstrations of our immersive VR educational experiences and get a preview of what awaits you in our virtual campus.
            </p>
          </motion.div>
        </div>
      </section>

      {/* Videos Grid */}
      <section className="py-8 pb-24">
        <div className="container-custom">
          {videos.length > 0 ? (
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
              {videos.map((video, index) => (
                <VideoCard
                  key={video.id}
                  video={video}
                  onClick={setSelectedVideo}
                  index={index}
                />
              ))}
            </div>
          ) : (
            <div className="text-center py-16">
              <p className="text-muted-foreground">No demo videos available yet. Check back soon!</p>
            </div>
          )}
        </div>
      </section>

      <VideoModal
        isOpen={!!selectedVideo}
        onClose={() => setSelectedVideo(null)}
        videoId={selectedVideo?.youtube_id}
        videoUrl={selectedVideo?.youtube_url}
        title={selectedVideo?.title}
      />
    </div>
  );
}
